<template>
  <div class="text-center">
    <div style="min-height: 350px">
      <v-text-field
        style="width: 50%"
        v-show="!hasParent"
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>

      <v-data-table
        v-show="!hasParent"
        class="mt-5"
        v-model="selected"
        :headers="headers"
        :items="buildings"
        :single-select="true"
        :search="search"
        :items-per-page="5"
        item-key="id"
        show-select
        dense
      >
      </v-data-table>
    </div>
    <v-btn @click="addParent">Ok</v-btn>
  </div>
</template>

<script>
import services from "../rest/Services";
import utility from "../utility/utility";
import EventBus from "../components/EventBus";
export default {
  props: {
    parentId: {
      type: Number,
      default: null,
    },
  },
  mounted: function () {
    this.getBuildings();
    EventBus.$on("saveBuildingSuccess", () => {
      this.selected = [];
    });
    EventBus.$on("resetParentSelection", () => {
      this.selected = [];
      this.$emit("addParent", null);
    });
  },

  data: function () {
    return {
      functionalUnits: [],
      headers: [
        { text: "Country", value: "country" },
        { text: "City", value: "city" },
        { text: "Adress", value: "adress" },
        { text: "Building usage", value: "building_type_usage" },
        { text: "Floor area (m2)", value: "floor_area" },
      ],
      buildings: [],
      search: "",
      hasParent: false,
      selected: [],
    };
  },
  methods: {
    getBuildings() {
      services
        .getFunctionalUnits({
          functional_unit_types: ["BUILDING"],
        })
        .then((response) => {
          this.functionalUnits = response.data.data;
          this.setBuildingsData();
        });
    },
    setBuildingsData: function () {
      let buildings = [];
      this.functionalUnits.forEach((object) => {
        let { functional_unit: funit } = object;
        buildings.push({
          id: funit.id,
          country: `${funit.address_data.country}`,
          city: `${funit.address_data.city}`,
          adress: `${funit.address_data.street} ${funit.address_data.street_number}`,
          building_type_usage: utility.convertStrToLabel(
            funit.building_type_usage
          ),
          floor_area: funit.floor_area,
        });
      });
      this.buildings = buildings;
      if (this.parentId) {
        this.selected.push(
          this.buildings.find((building) => building.id === this.parentId)
        );
      }
    },
    addParent: function () {
      const parent =
        this.selected.length > 0
          ? this.functionalUnits.find(
              (unit) => unit.functional_unit.id === this.selected[0].id
            ).functional_unit
          : null;
      this.$emit("addParent", parent);
    },
  },
  watch: {
    parentId: function (value) {
      if (value) {
        this.selected.length = 0;
        this.selected.push(
          this.buildings.find((building) => building.id === value)
        );
      }
    },
  },
};
</script>
